import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AppState } from '../../state/appState';
import { Observable, Subscription } from 'rxjs';
import { LanguageModel } from '../../shared/models/language.model';
import { ActivatedRoute } from '@angular/router';
import { StartLoading, StopLoading } from '../../state/actions/general.actions';
import { catchError, mergeMap } from 'rxjs/operators';
import { GetCashcutDetails } from '../../state/actions/merchant.actions';
import { RouteHome } from '../../state/actions/routing.actions';
import { CashcutDetailModel } from '../../shared/models/cashcutDetail.model';

@Component({
  selector: 'app-cashcut-details',
  templateUrl: './cashcut-details.component.html',
  styleUrls: ['./cashcut-details.component.scss'],
})
export class CashcutDetailsComponent implements OnInit, OnDestroy {
  @Select(AppState.cashcutDetails$)
  cashcutDetails$: Observable<CashcutDetailModel>;
  @Select(AppState.currentLanguage$)
  currentLanguage$: Observable<LanguageModel>;

  private subscriptions: Subscription[] = [];

  constructor(private store: Store, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.activatedRoute.params.subscribe((p) => {
        this.store
          .dispatch(new StartLoading())
          .pipe(
            mergeMap(() =>
              this.store.dispatch(new GetCashcutDetails(p.cashcutId))
            ),
            mergeMap(() => this.store.dispatch(new StopLoading())),
            catchError((error) => {
              console.log(error);
              return this.store
                .dispatch(new RouteHome())
                .pipe(mergeMap(() => this.store.dispatch(new StopLoading())));
            })
          )
          .subscribe();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onGoHome(): void {
    this.store.dispatch(new RouteHome());
  }
}
